// Which social sign-in providers are offered on the sign-in / sign-up screens.
//
// Plain constants rather than REACT_APP_* env vars on purpose: both require a rebuild to change,
// and a constant can't drift between local and Vercel the way an env var can.
//
// Google sign-in is ordinary browser OAuth and has nothing to do with app stores — it works for
// any web user, so it stays on.
//
// Apple sign-in is OFF until launch. On the web it needs an Apple Developer Program membership, a
// Services ID, a registered return URL and a private key uploaded to Firebase; without that setup
// the button throws (`auth/operation-not-allowed`) the moment it's clicked. It'll be turned back on
// when the App Store build happens, at which point the developer-account setup exists anyway.
//
// BEFORE RE-ENABLING APPLE: the delete-account flow needs an Apple branch in its re-authentication
// step, the same way Google has one (see components/DeleteAccountDrawer.jsx). Without it, Apple
// users cannot delete their accounts — and App Store apps are *required* to offer in-app account
// deletion, so shipping it without that branch would fail review.
//
// Also note for iOS: Apple requires Sign in with Apple as an equivalent option in any App Store app
// that offers other third-party sign-in. Keeping Google in an iOS build therefore obliges Apple too.
export const GOOGLE_AUTH_ENABLED = true;
export const APPLE_AUTH_ENABLED = false;
